import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

interface Props extends LoadingButtonProps {
  isInfinte?: boolean;
  transtionEffect?: string;
  transitionDuration?: string;
  isHideTransparentBg?: boolean;
}

const ShiningButton = ({
  isInfinte,
  transtionEffect,
  transitionDuration,
  isHideTransparentBg,
  children,
  sx,
  ...res
}: Props) => {
  if (isInfinte) {
    return (
      <LoadingButton
        {...res}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          // Animate infinite
          '&::before': {
            content: '""',
            position: 'absolute',
            left: '-110%',
            top: -10,
            height: '150px',
            width: '20px',
            background: 'rgb(255 255 255 / 0.5)',
            opacity: 0.5,
            transform: 'rotate(20deg)',
            animation: `myEffectExit 1.5s linear infinite`,
          },
          '@keyframes myEffectExit': {
            '0%': {
              left: '-110%',
            },
            '99.9%': {
              left: '110%',
            },
            '100%': { left: '-110%' },
          },
          ...sx,
        }}
      >
        {children}
      </LoadingButton>
    );
  }
  return (
    <LoadingButton
      {...res}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...(!isHideTransparentBg && { background: 'transparent' }),
        '&:not(:last-child)': {
          marginBottom: '3rem',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          left: '-100%',
          top: 0,
          height: '100%',
          width: '100%',
          background: 'linear-gradient(120deg,transparent,rgba(255, 255, 255, 0.2),transparent)',
          opacity: 0.5,
          transition: transtionEffect || `all ${transitionDuration || '0.65s'} ease-in-out`,
        },
        '&:hover::before': {
          left: '100%',
        },
        '&:hover': {
          boxShadow: '1px 1px 10px 3px rgba(255, 255, 255, 0.15)',
          borderColor: 'transparent',
        },
        ...sx,
      }}
    >
      {children}
    </LoadingButton>
  );
};

export default ShiningButton;
